import Hero from "./HeroSection/Hero";

const Header: React.FC = () => {
  return <div>{/* <Hero /> */}</div>;
};

export default Header;
